/**
 * 在庫順ソート（2026-05-06 完全リライト：CSS order ベース）
 *
 * 仕組み:
 *   - sectionテンプレ側で <li class="grid__item" style="--tcg-inv: N"> を生成
 *   - CSS 側で order = var(--tcg-inv) * var(--tcg-sort-mult) を計算
 *   - DOM順は触らずに視覚順だけ並び替えるため、スクロール／追加読込時の位置ズレなし
 *
 * URL の sort_by:
 *   stock-desc → 在庫多い順（デフォルト・--tcg-sort-mult=-1）
 *   stock-asc  → 在庫少ない順（--tcg-sort-mult=1）
 *
 * このJSは sort 方向（multiplier）だけを操作し、DOM ソート処理は一切しない。
 */
(function () {
  'use strict';

  function applySortDirection() {
    const params = new URLSearchParams(window.location.search);
    const k = params.get('sort_by');
    if (k === 'stock-asc') {
      document.documentElement.style.setProperty('--tcg-sort-mult', '1');
    } else {
      // stock-desc / 未指定 / Shopifyネイティブ sort_by → デフォルトの -1（降順）
      document.documentElement.style.setProperty('--tcg-sort-mult', '-1');
    }
  }

  function init() {
    applySortDirection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // popstate / facet 切替で URL が変わったら multiplier 再計算
  window.addEventListener('popstate', applySortDirection);
  document.addEventListener('shopify:section:load', applySortDirection);
})();
